import { api } from 'src/utils/api';

const createOrUpdate = params => api.post('/debts', params);

const loadAssociationFields = () => api.get('/mapped-fields');

const remove = id => api.delete(`/debts/${id}`);

const fetchActions = (pkDebt, page) => api.get('/actions', {
    params: {
        debt: pkDebt,
        page,
    },
});

const fetchClientOperatorActions = (pkDebt, page) => api.get('/operator-event-client', {
    params: {
        debt: pkDebt,
        page,
    },
});

const fetchOperatorActions = (pkDebt, page) => api.get('/operator-event', {
    params: {
        debt: pkDebt,
        page,
    },
});

const activate = pkDebt => api.post('/debts/activate', {
    pk_debt: pkDebt,
});
const inactive = pkDebt => api.post('/debts/inactivate', {
    pk_debt: pkDebt,
});
const finish = pkDebt => api.post('/debts/finalize', {
    pk_debt: pkDebt,
});

const find = pkDebt => api.get(`/debts/${pkDebt}`);

const getInstallmentScenario = (debt, amount, installments, paymentInstallments, dueDate, entry_amount = null) => api.post('/operator/calc', {
    debt,
    amount,
    installments,
    payment_installments: paymentInstallments,
    due: dueDate,
    entry_amount,
});

const createOperatorActionRequest = params => api.post('/operator-event', params);

const getOperatorDebtSimulation = (pkDebt, due) => api.get('/operator/simulate', {
    params: {
        pk_debt: pkDebt,
        due,
    },
});

const getOperators = () => api.get('/operator/', {
    params: {
    },
});

const simulateDebtRequest = (pkDebt, due) => api.get('/debtor-area/simulate-debt', {
    params: {
        pk_debt: pkDebt,
        due,
    }
})

const operatorActivate = pkDebt => api.post('/operator/activate-debt', {
    pk_debt: pkDebt,
});

export {
    loadAssociationFields,
    createOrUpdate,
    remove,
    fetchActions,
    fetchOperatorActions,
    fetchClientOperatorActions,
    activate,
    inactive,
    finish,
    find,
    getInstallmentScenario,
    createOperatorActionRequest,
    getOperatorDebtSimulation,
    getOperators,
    simulateDebtRequest,
    operatorActivate,
};
